export default __webpack_public_path__ + "assets/img/process_loader-3.5f2c6c53.gif";